export default __webpack_public_path__ + "static/media/startup.9e28d216.svg";